import * as ActionTypes from '../actionTypes';


export const updateOperations = (data) => {
  return {
    type: ActionTypes.UPDATE_OPERATIONS,
    payload: {...data}
  };
};